export default {
	init: (utils, gsap, ScrollTrigger) => {

		// Desktop menu
        /////////////////////////////////////////////////////////////////////////////////
		const dropdownBtns = document.querySelectorAll('.js-header-dropdown-btn')
		let currentTl = null;

		if (dropdownBtns.length){

			dropdownBtns.forEach((btn, index) => {

				const dropdownEl = btn.querySelector('.headerMainNavSub');
				if (dropdownEl) {

					//Animation timeline
					const drodownTl = gsap.timeline({ paused: true })
					drodownTl.set(dropdownEl, { display: "block" }, 'start')
							.from(dropdownEl, { autoAlpha: 0, y: 40, duration: 0.3, ease: 'power1.inOut'}, 'start')

					//Events
					btn.addEventListener('mouseover', function(e){
						drodownTl.play();
						currentTl = drodownTl;

    					btn.setAttribute('aria-expanded', 'true');
					})
					
					btn.addEventListener('mouseleave', function(e){
						drodownTl.reverse();
						currentTl = null;

						btn.setAttribute('aria-expanded', 'false');
					})

					btn.addEventListener('keydown', function(e){
						if (e.key === 'Enter') {
						  	if(btn.classList.contains('--opened')){
								drodownTl.reverse();
								currentTl = null;
								btn.classList.remove('--opened')
								btn.setAttribute('aria-expanded', 'false');
							} else {
								drodownTl.play();
								currentTl = drodownTl;
								btn.classList.add('--opened')
								btn.setAttribute('aria-expanded', 'true');
							}
						}

						if(e.key === 'Escape'){
							drodownTl.reverse();
							currentTl = null;
							btn.classList.remove('--opened')
							btn.setAttribute('aria-expanded', 'false');
						}
					});

				}

			})
		}

		//Accessibility
		const focusableButtons = document.querySelectorAll('.js-header-focusable-btn')
		focusableButtons.forEach(btn => {
			btn.addEventListener('focus', function(e){
				if (currentTl) {
					currentTl.reverse()
				}
			})
		});

		// Message
        /////////////////////////////////////////////////////////////////////////////////
		const messageEl = document.querySelector('.js-header-message')
		
		if (messageEl) {
			const messageDate = messageEl.dataset.modified;
			const messageButton = document.querySelector('.js-header-message-close');

			messageButton.addEventListener('click', function(e){
				e.preventDefault()
				messageEl.classList.add('--inactive')
				utils.setCookie('message_disabled', messageDate, 7);
				utils.setCSSVariables('--header-height', `${header.offsetHeight}px`)
			})
		}

		// Scrolling header
		/////////////////////////////////////////////////////////////
		const body = document.querySelector('body');
	  
		ScrollTrigger.create({
			markers: false,
			trigger: body,
			start: 'top -5%',
			onUpdate: self => {
				if (self.direction === 1) {
					body.classList.add('--scrolling-down');
					body.classList.remove('--scrolling-up');
				} else if(self.progress === 0) {
					body.classList.remove('--scrolling-up');
				} else {
					body.classList.add('--scrolling-up');
					body.classList.remove('--scrolling-down');
				}
			},
			onLeaveBack: () => {
				body.classList.remove('scrolling-up');
			},
		});

	}
}